var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeolocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.9998 2.06031C9.44572 2.24194 7.97144 2.84703 6.73785 3.8095C5.50427 4.77197 4.55881 6.05484 4.00469 7.51807C3.45056 8.98129 3.30907 10.5686 3.59565 12.1068C3.88223 13.645 4.58588 15.0748 5.62978 16.2403L9.99978 21.0903C10.2529 21.3694 10.5616 21.5924 10.906 21.745C11.2505 21.8976 11.623 21.9765 11.9998 21.9765C12.3765 21.9765 12.7491 21.8976 13.0935 21.745C13.438 21.5924 13.7467 21.3694 13.9998 21.0903L18.3498 16.2403C19.5006 14.9473 20.2319 13.3355 20.4469 11.6179C20.6619 9.90039 20.3505 8.15803 19.554 6.62125C18.7574 5.08447 17.5132 3.82566 15.9857 3.01127C14.4583 2.19689 12.7197 1.86528 10.9998 2.06031ZM11.9998 13.7503C11.3645 13.7523 10.7429 13.5657 10.2137 13.2142C9.68449 12.8627 9.2715 12.362 9.027 11.7757C8.78251 11.1893 8.71752 10.5436 8.84024 9.92022C8.96297 9.29688 9.2679 8.72398 9.71643 8.27406C10.165 7.82413 10.7369 7.51741 11.3599 7.39274C11.9828 7.26807 12.6287 7.33105 13.2159 7.57371C13.803 7.81637 14.3049 8.2278 14.6581 8.75589C15.0113 9.28399 15.1998 9.90501 15.1998 10.5403C15.1998 11.3899 14.863 12.2049 14.2631 12.8066C13.6633 13.4083 12.8494 13.7477 11.9998 13.7503Z",
    fill: "#424C9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 13.8401C13.8664 13.8401 15.3796 12.3268 15.3796 10.4601C15.3796 8.59336 13.8664 7.08008 11.9996 7.08008C10.1329 7.08008 8.61963 8.59336 8.61963 10.4601C8.61963 12.3268 10.1329 13.8401 11.9996 13.8401Z",
    fill: "#424C9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocation);
export default __webpack_public_path__ + "static/media/geolocation.c495471c002fc69e9b12a475af84260e.svg";
export { ForwardRef as ReactComponent };